<template>
  <div class="teladv between">
    <div class="teladv_item">
      <div class="adv_ic">
        <img src="../../../assets/telzx/rx.png" alt="" />
      </div>
      <div class="adv_na">真正的专家</div>
      <div class="adv_de">
        提供电话咨询服务的律师全部经过当地律协认证，有国家签发的律师执业证，业务能力在专业领域内权威。
      </div>
    </div>
    <div class="teladv_item">
      <div class="adv_ic">
        <img src="../../../assets/telzx/aqs.png" alt="" />
      </div>
      <div class="adv_na">绝对隐私</div>
      <div class="adv_de">
        您的资料信息只有被咨询律师可以审阅详情，一对一电话沟通，确保您的个人隐私安全性。
      </div>
    </div>
    <div class="teladv_item">
      <div class="adv_ic">
        <img src="../../../assets/telzx/zfj.png" alt="" />
      </div>
      <div class="adv_na">更方便、更轻松</div>
      <div class="adv_de">
        足不出户就可以享受专业的沟通业务，在自己隐私的空间，不受任何人打扰，轻松地与律师交流案情。
      </div>
    </div>

    <div class="teladv_item">
      <div class="adv_ic">
        <img src="../../../assets/telzx/hb.png" alt="" />
      </div>
      <div class="adv_na">更实惠</div>
      <div class="adv_de">
        为您节省交通费用、预约等待的时间成本。为异地、疑难、真正需要专业律师咨询的用户提供更实惠便利的服务。
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scope>
.teladv {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .teladv_item {
    text-align: center;
    width: 238px;
    .adv_ic {
      margin-bottom: 18px;
    }
    .adv_na {
      font-size: 20px;
      color: #333333;
      line-height: 20px;
    }
    .adv_de {
      margin-top: 13px;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
    }
  }
}
</style>